/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Card, Select } from "components"
import { TbChevronRight } from "react-icons/tb"
import { useNavigate } from "react-router-dom"
import { useDropdownGroupAsset } from "pages/ManagementAssets/Transaction/ProfileAsset/utils"
import { PERMISION } from "security"

export function RegisterByGroupFiltered({ filter, setFilter }: RegisterByGroupFiltered) {
  const navigate = useNavigate()
  const dropdownGroupAsset = useDropdownGroupAsset()
  const dropdownUsage = [
    { value: "false", label: "ACTIVE ASSET" },
    { value: "true", label: "ASSET DISPOSAL" }
  ]

  return (
    <Card>
      <Card.Body>
        <section className="container flex-col lg:flex lg:flex-row justify-center lg:justify-between lg:items-end pt-1">
          <div className="w-full lg:w-1/2 flex-col lg:flex lg:flex-row justify-center lg:justify-start items-center lg:gap-3 mb-1">
            <Select
              label="ASSET GROUP"
              placeholder="Select asset group"
              isLoading={dropdownGroupAsset?.isLoading}
              options={[{ value: "", label: "ALL" }, ...dropdownGroupAsset?.data]}
              onChange={(val ) => setFilter({ ...filter, group_id: String(val?.value) })}
            />

            <Select
              label="STATUS"
              placeholder="Select usage"
              isLoading={dropdownGroupAsset?.isLoading}
              options={dropdownUsage}
              onChange={(val ) => setFilter({ ...filter, usage: val?.value! })}
            />
          </div>

          <Button 
            permission={PERMISION.ASET_MANAGEMENT.REGISTER.BY_GROUP.CREATE}
            className="mb-1" 
            color="primary"
            onClick={() => navigate("/asset-management/transaction/profile-asset")}
          >
            CREATE PROFILE ASSETS <TbChevronRight /> 
          </Button>
        </section>
      </Card.Body>
    </Card>
  )
}

// eslint-disable-next-line
type RegisterByGroupFiltered = { 
  filter: { group_id: string, usage: string },
  setFilter: (val: { group_id: string, usage: string }) => void 
}